"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelHeading = exports.CancelFormWrapper = exports.CancelSideBar = exports.CancelTextContainer = exports.CancelContentContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const breakpoints_1 = require("../../../lib/constants/breakpoints");
exports.CancelContentContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_small')}) {
    flex-direction: initial;
  }
`;
exports.CancelTextContainer = (0, styled_1.default)('div') `
  flex: auto;
  z-index: 1;
`;
exports.CancelSideBar = (0, styled_1.default)('div') `
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_small')}) {
    position: relative;
    top: -35px; // negative values to align sidebar with page heading
    max-width: ${breakpoints_1.SIDEBAR_WIDTH};
  }
`;
exports.CancelFormWrapper = (0, styled_1.default)('div') `
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_small')}) {
    width: 80%;
  }
`;
exports.CancelHeading = (0, styled_1.default)('h2') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_small')}) {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
`;
//# sourceMappingURL=styles.js.map